import { useCallback, useEffect, useState } from "react";
import {
  APP_VERSION,
  createVersionChecker,
  isVersionCheckEnabled,
  shouldReshow,
} from "./version-check";

const PERIODIC_CHECK_INTERVAL_MS = 15 * 60_000;

export function useNewVersion() {
  const [newVersionFound, setNewVersionFound] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!isVersionCheckEnabled(APP_VERSION)) return;

    let hiddenAt: number | null = null;
    const checker = createVersionChecker({
      bundleVersion: APP_VERSION,
      onNewVersion: () => {
        clearInterval(periodicCheck);
        setNewVersionFound(true);
      },
    });
    const check = () => void checker.check();
    const checkIfVisible = () => {
      if (document.visibilityState === "visible") check();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        hiddenAt = Date.now();
        return;
      }
      if (shouldReshow(hiddenAt, Date.now())) setDismissed(false);
      hiddenAt = null;
      check();
    };

    const periodicCheck = setInterval(checkIfVisible, PERIODIC_CHECK_INTERVAL_MS);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("focus", check);
    return () => {
      clearInterval(periodicCheck);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("focus", check);
    };
  }, []);

  const dismissNotice = useCallback(() => setDismissed(true), []);

  return { showNotice: newVersionFound && !dismissed, dismissNotice };
}
